import { dependOn, itemRules, maxLength, required } from 'common/utils/validatorService'
import i18n from 'i18next'

export const TABS = {
    playground: 1,
    tiles: 2,
    finalScreen: 3,
}

export const TABS_ARRAY = [
    {
        id: 1,
        label: i18n.t('Playground'),
    },
    {
        id: 2,
        label: i18n.t('Tiles'),
    },
    {
        id: 3,
        label: i18n.t('Final screen'),
    },
]

export const LAYOUT_TEMPLATE = [
    {
        value: 1,
        rows: 1,
        cols: 1,
        label: '1x1',
    },
    {
        value: 4,
        rows: 2,
        cols: 2,
        label: '2x2',
    },
    {
        value: 9,
        rows: 3,
        cols: 3,
        label: '3x3',
    },
]

export const PLAYGROUND_FIELDS = {
    layout: 'layout',
    image: 'image',
    isShowCover: 'isShowCover',
    coverHeader: 'coverHeader',
    coverButtonText: 'coverButtonText',
}

export const TILES_FIELDS = {
    tileList: 'tileList',
}

export const TAB_TO_FIELD_MAP = {
    [TABS.playground]: 'playground',
    [TABS.tiles]: 'tiles',
    [TABS.finalScreen]: 'finalScreen',
}

export const VALIDATE_RULES_FIELDS = {
    playground: {
        layout: [required()],
        image: [],
        coverHeader: [
            dependOn(({ self }) => {
                return self.isShowCover ? required() : null
            }),
        ],
        coverButtonText: [
            dependOn(({ self }) => {
                return self.isShowCover ? required() : null
            }),
        ],
    },
    tiles: {
        tileList: [
            itemRules({
                id: [required()],
                password: [required()],
                buttonLink: [],
                buttonText: [],
                color: [],
                headerImgSrc: [],
                imgSrc: [],
                overlaySrc: [],
                quest: [maxLength(60)],
                questDescription: [],
                showQuest: [],
            }),
        ],
    },
    finalScreen: {
        header: [required()],
    },
}

export const STANDARD_MODAL_PREVIEW_HEIGHT = 280

export const RECTANGLE_MODAL_PREVIEW_HEIGHT = 95

export const STANDARD_PREVIEW_HEIGHT = 800

export const RECTANGLE_PREVIEW_HEIGHT = 266

export const FIXED_TOP_OFFSET_FOR_SCROLL = 36

export const TILE_BACKGROUND_COLOR = ['#FFFFFF', '#69B1FC', '#65BB5A', '#FF5656', '#FFAA2C', '#86469C', '#000000']

export const colNumberToSize = {
    1: 'large',
    2: 'medium',
    3: 'small',
}
